export default "__VITE_ASSET__434efa03__"